const ROUTES = [
  'GET /v1/business',
  'GET /v1/business/owned-wabas',
  'GET /v1/business/:business_id',
  'GET /v1/business/:business_id/shared-wabas',
  'GET /v1/business/:business_id/extended-credits',
  'GET /v1/waba/subscriptions',
  'POST /v1/waba/subscriptions',
  'DELETE /v1/waba/subscriptions',
  'POST /v1/waba/debug-token',
  'POST /v1/messages',
  'POST /v1/messages/read',
  'PUT /v1/messages/:phoneNumberId/status',
  'GET /v1/templates',
  'GET /v1/templates/:TEMPLATE_ID',
  'GET /v1/templates/name/:TEMPLATE_NAME',
  'POST /v1/templates',
  'PUT /v1/templates/:TEMPLATE_ID',
  'DELETE /v1/templates/:TEMPLATE_ID',
  'DELETE /v1/templates/name/:TEMPLATE_NAME',
  'GET /v1/media/download/:media_id',
  'GET /v1/media/:media_id',
  'POST /v1/media/upload',
  'DELETE /v1/media/:media_id',
  'GET /v1/qr-codes',
  'GET /v1/qr-codes/all',
  'GET /v1/qr-codes/all/fields',
  'GET /v1/qr-codes/:QR_CODE_ID',
  'GET /v1/qr-codes/:QR_CODE_ID/image',
  'POST /v1/qr-codes',
  'PUT /v1/qr-codes/:QR_CODE_ID',
  'DELETE /v1/qr-codes/:QR_CODE_ID',
  'GET /v1/phone-numbers',
  'GET /v1/phone-numbers/:phoneNumberId',
  'GET /v1/phone-numbers/:phoneNumberId/name-status',
  'POST /v1/phone-numbers/:phoneNumberId/request-code',
  'POST /v1/phone-numbers/:phoneNumberId/verify-code',
  'POST /v1/phone-numbers/:phoneNumberId/two-step-verification',
  'POST /v1/phone-numbers/:phoneNumberId/register',
  'POST /v1/phone-numbers/:phoneNumberId/deregister',
  'GET /v1/users/:phoneNumberId/blocked',
  'POST /v1/users/:phoneNumberId/blocked',
  'DELETE /v1/users/:phoneNumberId/blocked',
  'GET /v1/business-profiles/:phoneNumberId',
  'POST /v1/business-profiles/:phoneNumberId',
  'GET /v1/business-profiles/:phoneNumberId/compliance',
  'POST /v1/business-profiles/:phoneNumberId/compliance',
  'GET /v1/business-profiles/:phoneNumberId/encryption',
  'POST /v1/business-profiles/:phoneNumberId/encryption',
  'GET /v1/commerce/:phoneNumberId/settings',
  'PUT /v1/commerce/:phoneNumberId/settings',
  'GET /v1/flows',
  'POST /v1/flows',
  'POST /v1/flows/:wabaId/migrate',
  'GET /v1/flows/:flowId/assets',
  'POST /v1/flows/:flowId/assets',
  'POST /v1/flows/:flowId/publish',
  'POST /v1/flows/:flowId/deprecate',
  'GET /v1/flows/:flowId',
  'PUT /v1/flows/:flowId',
  'DELETE /v1/flows/:flowId',
  'POST /v1/uploads/sessions',
  'POST /v1/uploads/sessions/:uploadId',
  'GET /v1/uploads/sessions/:uploadId'
];

export const hawktrionApiRoutes = ROUTES.map((route) => {
  const [method, routePath] = route.split(' ');
  return {
    method: method.toLowerCase(),
    path: routePath.replace(/:([A-Za-z0-9_]+)/g, '{$1}')
  };
});
